import React from 'react';
import { TextStyled } from '@nike/nike-design-system-components';
import clsx from 'clsx';
import { KOREAN_FOOTER_CONSTANTS } from './constants';

import Link from '../Link';
import { KoreanLegalFooterContainer, section, inlineButton, link } from './style';
import useBodega from '../../utils/hooks/bodegaHook';
import FormattedTranslation from '../FormattedTranslation';
import KoreanLearnMoreModal from './korean-modal';

/**
 * KoreanLegalFooter component. Korea needs extra legal info under the usual footer
 * @returns {*}
 */
const KoreanLegalFooter = () => {
  const launchKoreanPopUp = () => {
    window.open(
      KOREAN_FOOTER_CONSTANTS.KOREAN_ESCROW_PAYMENT_URL,
      'mark',
      'scrollbars=no,resizable=no,width=565,height=683',
    );
  };
  const baseClickEventPayload = { type: 'click_navFooter', path: '' };
  return (
    <KoreanLegalFooterContainer data-testid="korean-legal-footer-container">
      <div className={section}>
        <TextStyled>
          <FormattedTranslation
            defaultValue={'Business Info'}
            translationId={'nav_business_information_text'}
            values={{
              phone: KOREAN_FOOTER_CONSTANTS.KOREAN_BUSINESS_INFO_PHONE + ' ',
            }}
          />
          <Link
            className={link}
            clickEventPayload={{
              ...baseClickEventPayload,
              path: 'business information confirmation',
            }}
            data-var="koreanBusinessInfoLink"
            href={KOREAN_FOOTER_CONSTANTS.KOREAN_BUSINESS_INFO_URL}
            target="_blank"
          >
            {useBodega('nav_business_information_link_text', 'Business Info Confirmation')}
          </Link>
        </TextStyled>
        <TextStyled>
          <FormattedTranslation
            defaultValue={'Customer Service'}
            translationId={'nav_customer_service_text'}
            values={{
              email: (
                <Link
                  className={link}
                  clickEventPayload={{ ...baseClickEventPayload, path: 'customer service email' }}
                  data-var="koreanCustomerServiceEmail"
                  href={`mailto:${KOREAN_FOOTER_CONSTANTS.KOREAN_CUSTOMER_SERVICE_EMAIL}`}
                  key="koreanCustomerServiceEmail"
                >
                  {KOREAN_FOOTER_CONSTANTS.KOREAN_CUSTOMER_SERVICE_EMAIL}
                </Link>
              ),
              fax: KOREAN_FOOTER_CONSTANTS.KOREAN_CUSTOMER_SERVICE_FAX,
              phone: (
                <Link
                  className={link}
                  clickEventPayload={{ ...baseClickEventPayload, path: 'customer service phone' }}
                  data-var="koreanCustomerServicePhone"
                  href={`tel:${KOREAN_FOOTER_CONSTANTS.KOREAN_CUSTOMER_SERVICE_PHONE}`}
                  key="koreanCustomerServicePhone"
                  path="customer service phone"
                >
                  {KOREAN_FOOTER_CONSTANTS.KOREAN_CUSTOMER_SERVICE_PHONE}
                </Link>
              ),
            }}
          />
        </TextStyled>
      </div>
      <div className={section}>
        <TextStyled>
          <FormattedTranslation
            defaultMessage="Payment Text"
            translationId={'nav_payment_information_text'}
            values={{
              company: (
                <Link
                  className={clsx(inlineButton, link)}
                  clickEventPayload={{
                    ...baseClickEventPayload,
                    path: 'secure payment notification',
                  }}
                  data-var="koreanSecurePaymentIcon"
                  key="koreanSecurePaymentIcon"
                  onClick={launchKoreanPopUp}
                >
                  {useBodega('nav_businness_company_text', '결제대금예치')}
                </Link>
              ),
            }}
          />
        </TextStyled>
        <TextStyled>
          {useBodega('nav_legal_info_text', 'Information on Content Protection') + ' '}
          <KoreanLearnMoreModal />
        </TextStyled>
      </div>
    </KoreanLegalFooterContainer>
  );
};

export default KoreanLegalFooter;
